

import getParkOverviewInfo from './getParkOverviewInfo.js';
import getParkPlanningInfo from './getParkPlanningInfo';
import getParkInvestmentInfo from './getParkInvestmentInfo';
import getParkOperationInfo from './getParkOperationInfo';
import getParkBuildingInfo from './getParkBuildingInfo';
import getProjectData from './getProjectData';
import getBuildingData from './getBuildingData';
import getParkingData from './getParkingData';
import getAdData from './getAdData';
import getOrganizationData from './getOrganizationData';
import getParkConstructionInfo from './getParkConstructionInfo';

export default {
    getParkOverviewInfo,
    getParkPlanningInfo,
    getParkInvestmentInfo,
    getParkOperationInfo,
    getParkBuildingInfo,
    getProjectData,
    getBuildingData,
    getParkingData,
    getAdData,
    getOrganizationData,
    getParkConstructionInfo,
}